function isPage(uri) {
	
	if (window.location.pathname.indexOf(uri) !== -1) {
		return true;
	}
	
	return false;
}

export default isPage;